import React from 'react';
import { Box, Hint, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  fill: ${({ theme }) => theme.colors.iconDisabled};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    opacity: 1;
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
`;

const HINT_TEXT = `Plan Omnibus shows the plan’s net funding balance based on recorded account activity,
 including deposits, spending, transfers, and adjustments.
  This amount is transaction-based and may differ from the physical bank balance due to activity processed within the system outside of banking hours.`;

interface Props {
  testId?: string;
}

const BankingBalancePlanOmnibusHint: React.FC<Props> = ({ testId }) => (
  <Hint
    data-testid={testId}
    hintElevation="default"
    contentStyles={{
      marginLeft: '0',
      width: '320px',
    }}
    hintElement={
      <StyledInfoIcon
        data-testid={testId ? `${testId}_icon` : undefined}
        size="16px"
        color="iconOnColor"
      />
    }
  >
    <Box>
      <Inscription size="small">
        {HINT_TEXT}
      </Inscription>
    </Box>
  </Hint>
);

export default BankingBalancePlanOmnibusHint;
